
export default function FooterAdmin() {
  return (
    <footer className="footer-admin">
      <div>&nbsp;</div>
    </footer>
  )
}
